@if (parkingWarningHtml(); as parkingHtml) {
  <cfp-alert [alertStyle]="'light'">
    <div [innerHtml]="parkingHtml"></div>
  </cfp-alert>
} @else if (warningKey(); as key) {
  <cfp-alert
    [alertStyle]="'light'"
    [title]="'portfolioBuildingsRoadmapReport.buildings.alert.title' | translate"
    [titleClasses]="'report-building-energy-label-alert-title'"
  >
    <div
      [innerHtml]="
        key
          | translate
            : {
                label: alertEnergyLabel()?.label,
                validUntil: (alertEnergyLabel()?.validUntil | date: 'longDate')
              }
      "
    ></div>
  </cfp-alert>
}
